import { Alert, Col, Form, FormInstance, Input, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { CustomerRegistration } from '@/models';

import { AddressInput } from '../shared/AddressInput';

type WebCustomerRegistrationFormProps = {
  form: FormInstance<CustomerRegistration>;
  onFinish: (customer: CustomerRegistration) => void;
};

export const WebCustomerRegistrationForm = ({
  form,
  onFinish,
}: WebCustomerRegistrationFormProps) => {
  const { t } = useTranslation();
  const streetValue = Form.useWatch('street', form);
  return (
    <Form form={form} layout='vertical' onFinish={onFinish}>
      <Row gutter={[12, 12]}>
        <Col xs={24} md={24}>
          <Alert
            message={t('forms:newCustomerAlert')}
            description={t('forms:newCustomerAlertDescription')}
            type='info'
            showIcon
          />
        </Col>
        <Col xs={24} md={24}>
          <Form.Item label={t('forms:company')} name={['company']} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:street')} name={['street']} rules={[{ required: true }]}>
            <AddressInput
              placeholder={t('forms:street')}
              value={streetValue}
              onChange={(value) => {
                form.setFieldsValue({ street: value });
              }}
              onSelect={(label, value) => {
                form.setFieldsValue({
                  street: `${value.street ?? ''} ${value.houseNumber ?? ''}`.trim(),
                  zip: value.postalCode,
                  city: value.city,
                  country: value.countryName,
                });
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={t('forms:department')}
            name={'supplement'}
            rules={[{ required: false }]}
            tooltip={t('forms:departmentTooltip')}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:zip')} name={'zip'} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:city')} name={'city'} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={24}>
          <Form.Item
            hidden={true}
            label={t('forms:country')}
            name={'country'}
            rules={[{ required: true }]}
            initialValue={'Deutschland'}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:firstname')} name={'firstName'} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:lastname')} name={'lastName'} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:email')} name={'email'} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item label={t('forms:phone')} name={['phone']} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
